(function ($) {
    $(document).ready(function() {
        //* Clones the first parent of a dropdown so we can click on it
        $('.sidebar ul').find('.page_item_has_children').each(function() {
            var submenu = $(this).find('.children');

            //* clones all parent elements w/ children and adds a special class to them, then attaches it to its own child menu
            $(this).clone().addClass('cloned').prependTo(submenu);
            $(this).find('.cloned a').text('Overview');

            //* Removes the class that makes it expand
            $('.cloned').removeClass('page_item_has_children');

            //* Removes the children of the cloned
            $('.cloned').find('.children').remove();
        });

        //* Starts items in closed state
        $('.sidebar ul').find('.page_item_has_children').attr('aria-expanded', 'false');
        $('.sidebar ul').find('.current_page_parent').addClass('show');

        //* On click
        $('.sidebar .page_item_has_children > a').click(function(e) {
            e.preventDefault(); 

            //* Open unless it's already open, then close
            if ($(this).parent().hasClass('show')) {
                $(this).parent().removeClass('show').attr('aria-expanded', 'false');
            } else {
                //* Close all other open
                $('.sidebar .page_item_has_children').removeClass('show').attr('aria-expanded', 'false');
                $(this).parent().addClass('show').attr('aria-expanded', 'true');
            }
        });
    });
}(jQuery));